/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';
import { media } from '@minecraft.themes';

export type WithIsPreview = {
  isPreview?: boolean;
};

export const AnchorButton = styled.span`
  font-size: 1rem;
  font-weight: 500;
  color: ${(props): string => props.theme.colors.primary.primary};
  cursor: pointer;
  &:hover {
    text-decoration: none !important; // to override the defualt styling coming from MineCraft
  }
`;

export const UserInfoContainer = styled.div<WithIsPreview>`
  background: ${(props): string => props.theme.colors.accent.ltGrey2};
  margin: 0 -1rem 0;
  padding: ${(props): string => (props.isPreview ? '0' : '0 1rem 1rem')};
  ${media.sm`
    margin: 0 -2rem 0;
    padding: 1rem 2rem;
  `}
`;

export const InfoHeading = styled.h3`
  font-size: 1.7rem;
  line-height: 2rem;
  padding-left: 2rem;
  margin-bottom: 0.5rem;
  ${media.sm`
    padding-left: 3rem;
  `}
`;
